<template>
    <div v-show="hasContent || showIf" class="row">
        <div class="col-md-4 col-lg-3 col-xl-2">
            <h2 class="d-none d-md-block">{{ heading }}</h2>
        </div>
        <div class="col-md-8 col-lg-9 col-xl-10">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "EventEntryDetailsHeading",
    props: {
        heading: {
            type: String,
            required: true
        },
        showIf: {
            type: Boolean
        }
    },
    provide() {
        return {
            setHasContentTrue: this.setHasContentTrue
        }
    },
    data() {
        return {
            hasContent: false
        }
    },
    methods: {
        setHasContentTrue() {
            this.hasContent = true
        }
    }
}
</script>

<style scoped>

</style>
